import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import axiosInstance from '../utils/api';

export default function RequireMFA({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [mfaEnabled, setMfaEnabled] = useState(false);

  useEffect(() => {
    checkMFAStatus();
  }, []);

  const checkMFAStatus = async () => {
    try {
      const response = await axiosInstance.get('/api/mfa/status/');
      const { mfa_enabled, is_staff } = response.data;

      // Only enforce MFA for staff users
      if (is_staff && !mfa_enabled) {
        // If not on MFA settings page, redirect there
        if (location.pathname !== '/mfa-settings') {
          navigate('/mfa-settings', {
            state: { forced: true, from: location.pathname }
          });
        }
      } else {
        setMfaEnabled(true);
      }

      setLoading(false);
    } catch (error) {
      console.error('Failed to check MFA status:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
}
